import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IRouteDetail, IRouteList, IPagination } from '../models';
import { RouteEndpoint } from '../endpoints/route';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StringUtil } from '@shared/utils';

/**
 * ### **ContactService**
 *
 * Un Servicio en Angular es el mecanismo para compartir funcionalidad entre componentes, en este caso se encarga de de compartir las funciones
 * hacen diferentes peticiones o llamados a distintos API's que genera el backend.
 */
@Injectable({
  providedIn: 'root',
})
export class Route {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  /** @ignore*/
  constructor() {}

  /**
   * Función encargda de realizar una petición get y obtener la ruta turística.
   * @param slug Parametro que guarda el slug de la ruta.
   */
  get(slug: string): Observable<IRouteDetail> {
    return this.http.get<IRouteDetail>(StringUtil.format(RouteEndpoint.routeDetail, slug));
  }

  /**
   * Función encargda de realizar una petición get y obtener la lista de  rutas turísticas.
   * @param url
   */
  list(url?: string): Observable<IPagination<Array<IRouteList>>> {
    return this.http.get<IPagination<Array<IRouteList>>>(url ? url : RouteEndpoint.route).pipe(
      catchError((error) => {
        this.router.navigate(['pages/404']);
        return throwError('Page dont exist');
      })
    );
  }
}
